import { forwardRef } from "react";
import type { ReactNode, SelectHTMLAttributes, TextareaHTMLAttributes } from "react";

import { cx } from "@akaike/ui";

interface FieldProps {
  label?: ReactNode;
  hint?: ReactNode;
  htmlFor?: string;
  className?: string;
  children: ReactNode;
}

export function Field({ label, hint, htmlFor, className, children }: FieldProps) {
  return (
    <div data-slot="field" className={cx("field", className)}>
      {label != null && (
        <label className="label" htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {children}
      {hint != null && <span className="hint">{hint}</span>}
    </div>
  );
}

export const NativeSelect = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    <select ref={ref} data-slot="native-select" className={cx("select", className)} {...props}>
      {children}
    </select>
  ),
);
NativeSelect.displayName = "NativeSelect";

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(({ className, ...props }, ref) => (
  <textarea ref={ref} data-slot="textarea" className={cx("textarea", className)} {...props} />
));
Textarea.displayName = "Textarea";
